import React from "react";
import { useState } from "react";

export const FullscreenPopup = ({
    className,
    style,
    trigger,
    fullscreenContent,
}: {
    className: string,
    style: React.CSSProperties;
    trigger: React.ReactNode;
    fullscreenContent: React.ReactNode;
}) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={className} style={style}>
            <div onClick={() => setIsOpen(true)} style={{ cursor: 'pointer' }}>
                {trigger}
            </div>

            {isOpen && (
                <div
                    onClick={() => setIsOpen(false)}
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "#fff",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999,
                        cursor: "zoom-out",
                    }}
                >
                    {fullscreenContent}
                </div>
            )}
        </div>
    );
};
